import Component from '@component';

export default class SignInEvent extends Component {
	onInit(el) {
		this.el = el;
	}

	onReady() {
		if (window.sessionStorage.getItem('userSignIn') === 'yes') {
			window.sessionStorage.removeItem('userSignIn');
		}
		this.el.addEventListener('click', this.clickOnSignIn.bind(this));
	}

	clickOnSignIn() {
		window.sessionStorage.setItem('userSignIn', 'yes');
	}
}
